import type {BunkSelection} from '../BunkOptions';
import type {PhotoPreviewDraft} from './RoomPhotoPreview';
import {DEFAULT_PLACEMENT} from './photo-placement';

/** Current selections own the count and options; a saved photo must never
 * resurrect a removed bunk or a previous finish. Keep only the room context. */
export function reconcilePhotoBunks(draft:PhotoPreviewDraft,bunks:BunkSelection[]):PhotoPreviewDraft{
 if(!bunks.length)return draft;
 const beds=bunks.map((selection,i)=>({...draft.beds[i],...selection,customColorCode:selection.customColorCode,id:i,
  placement:draft.beds[i]?.placement??{...DEFAULT_PLACEMENT},locked:false}));
 return {...draft,beds,active:Math.max(0,Math.min(draft.active,beds.length-1)),step:draft.step>=3?4:draft.step};
}
